<div [formGroup]="form" class="promotion-form">
  <ng-container *ngIf="shouldShowEmployeeInfo">
    <div class="form-group">
      <label class="form-control-label">Colaborador</label>
      <app-employee-info-display [employee]="data?.employee"></app-employee-info-display>
    </div>
  </ng-container>

  <div *ngIf="!isHidden('jobTitleGroupId')" class="form-group">
    <label class="form-control-label">Grupo de cargo</label>
    <ng-select class="auto-grow-options" [items]="jobTitleGroupOptions" bindLabel="label" bindValue="value"
      [loading]="showJobTitleGroupsLoading" [notFoundText]="jobTitleGroupNotFoundText" appendTo="body"
      placeholder="Grupo de cargo" formControlName="jobTitleGroupId" [readonly]="true">
    </ng-select>
    <ngb-alert *ngIf="shouldShowNoSeniorityGroupAlert" type="warning" [dismissible]="false" class="mt-1">
      O grupo de cargo atual do colaborador não possui senioridade configurada.
    </ngb-alert>
    <app-error-msg [control]="form.controls['jobTitleGroupId']" [label]="'Grupo de cargo'"></app-error-msg>
  </div>

  <div *ngIf="!isHidden('currentJobTitleId')" class="form-group">
    <label class="form-control-label">Função</label>
    <ng-select container="body" class="auto-grow-options"
      [attr.data-tooltip]="getSelectedOptionText(currentJobTitleOptions, form.get('currentJobTitleId')?.value)"
      [items]="currentJobTitleOptions" bindValue="value" bindLabel="label" placeholder="Função"
      formControlName="currentJobTitleId" [readonly]="true">
    </ng-select>
  </div>

  <div *ngIf="!isHidden('promotionType')" class="form-group">
    <label class="form-control-label">Subtipo da promoção</label>
    <ng-select class="auto-grow-options" [items]="promotionTypeOptions" bindLabel="label" bindValue="value"
      [clearable]="false" appendTo="body" placeholder="Subtipo da promoção"
      formControlName="promotionType" [readonly]="isScenarioSelectionReadonly">
    </ng-select>
    <app-error-msg [control]="form.controls['promotionType']" [label]="'Subtipo da promoção'"></app-error-msg>
  </div>

  <div class="form-group" *ngIf="(shouldShowDestinationJobTitle) && !isHidden('jobTitleId')">
    <label class="form-control-label">Nova função</label>
    <ng-select container="body" class="auto-grow-options" [loading]="showJobTitlesLoading" [items]="jobTitleOptions"
      bindLabel="label" bindValue="value" placeholder="Nova função" formControlName="jobTitleId"
      [notFoundText]="jobTitleNotFoundText" [readonly]="isScenarioSelectionReadonly"
      (change)="onJobTitleChange($event)">
    </ng-select>
    <app-error-msg [control]="form.controls['jobTitleId']" [label]="'Nova função'"></app-error-msg>
  </div>

  <app-salary-range-select *ngIf="!isHidden('salaryRange')" [jobTitleId]="form.get('jobTitleId')?.value" [control]="form.controls['salaryRange']"
    [required]="isSalaryRangeRequired" (rangeSelected)="onSalaryRangeSelected($event)"></app-salary-range-select>

  <ng-container *ngIf="canShowFieldsToChangeJobTitle">
    <div *ngIf="!isHidden('changeTypeCode')" class="form-group">
      <label class="form-control-label">Tipo de movimentação</label>
      <ng-select class="auto-grow-options" [items]="movementTypeOptions" bindLabel="label" bindValue="value"
        appendTo="body" placeholder="Tipo de movimentação" formControlName="changeTypeCode">
      </ng-select>
      <app-error-msg [control]="form.controls['changeTypeCode']" [label]="'Tipo de movimentação'"></app-error-msg>
    </div>

    <div class="form-group" *ngIf="(!hasSalaryRange) && !isHidden('newSalary')">
      <label class="form-control-label">Salário</label>
      <input type="text" class="form-control" formControlName="newSalary" placeholder="R$ 0,00" appCurrencyCentsInput />
      <app-error-msg [control]="form.controls['newSalary']" [label]="'Salário'"></app-error-msg>
    </div>
  </ng-container>

  <ng-container *ngIf="canShowExecutionDate">
    <div *ngIf="!isHidden('executionDate')" class="form-group">
      <label class="form-control-label">Data da Execução</label>
      <input type="date" class="form-control" formControlName="executionDate" />
      <app-error-msg [control]="form.controls['executionDate']" [label]="'Data da Execução'"></app-error-msg>
    </div>
  </ng-container>

  <div *ngIf="!isHidden('hasDangerousness')" class="form-group">
    <div class="d-flex gap-2 mb-small">
      <label class="form-control-label" for="promotionHasDangerousness">Possui Periculosidade?</label>
      <div class="custom-control custom-switch custom-switch-success">
        <input type="checkbox" class="custom-control-input" id="promotionHasDangerousness" formControlName="hasDangerousness" />
        <label class="form-control-label custom-control-label" for="promotionHasDangerousness">
          <span class="switch-icon-left"><i data-feather="check"></i></span>
          <span class="switch-icon-right"><i data-feather="x"></i></span>
        </label>
      </div>
    </div>
  </div>

  <div *ngIf="!isHidden('unhealthinessType')" class="form-group">
    <label class="form-control-label">Insalubridade</label>
    <ng-select class="auto-grow-options" [items]="unhealthinessOptions" bindLabel="label" bindValue="value"
      appendTo="body" placeholder="Insalubridade" formControlName="unhealthinessType">
    </ng-select>
    <app-error-msg [control]="form.controls['unhealthinessType']" [label]="'Insalubridade'"></app-error-msg>
  </div>

  <div class="form-group">
    <label class="form-control-label">Justificativa</label>
    <textarea rows="4" class="form-control" formControlName="note"></textarea>
    <app-error-msg [control]="form.controls['note']" [label]="'Justificativa'"></app-error-msg>
  </div>
</div>
